import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  Title,
  Spinner,
  HttpService,
  API,
  DateFormat,
  swal,
  Messages,
  toast
} from '../../../config/react'
import DataTable from 'react-data-table-component'
const ShippingRates = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const [ShippingRatesList, setShippingRatesList] = useState()
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [SearchTerm, setSearchTerm] = useState('')

  const columns = [
    {
      name: 'Name',
      sortField: 'Name',
      selector: (row) => row.name,
      sortable: true
    },
    {
      name: 'Rate',
      selector: (row) => row.rate
    },
    {
      name: 'Min Order Amount',
      selector: (row) => row.min_freeshipping_amount
    },
    {
      name: 'Create Date',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>,
      sortField: 'created_at',
      sortable: true
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/system/shippingrate/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>

          <Link
            className="text-dark"
            onClick={(e) => {
              DeleteShippingRate(e, row.id)
            }}
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Name, Rate, Min Order Amount."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })
  const DefaultFilters = {
    page: 1,
    // search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()
  useEffect(() => {
    setIsAuth(true)
    document.title = Title.ShippingRate
    GetShippingRateList()
  }, [CustomFilters, SearchTerm])
  const GetShippingRateList = () => {
    const param = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.GetShippingRate, param).then((response) => {
      setLoading(false)
      if (response.data.status === true && response.data.result !== '') {
        const data = response.data.result
        setShippingRatesList(data[1])
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total)
      } else {
        setShippingRatesList([])
        settotalRows(0)
      }
    })
  }

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }

  const handleSort = (e, direction) => {
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  const DeleteShippingRate = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id: id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteShippingRate, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetShippingRateList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.ShippingRate} </h3>
        <div className="btn-group">
          <Link
            to="/system/shippingrate/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            {Title.AddShippingRate}{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={ShippingRatesList}
                  pagination
                  paginationServer
                  persistTableHead={true}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  paginationDefaultPage={currentPage}
                  sortServer
                  progressPending={loading}
                  progressComponent={<Spinner />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ShippingRates
